enum VisitType {
  Prescription = 1,
  Investigation = 2,
  Referral = 3
}
export const CommunityBasedTrainingPatientEnum = {
  VisitType
}
